<header id="main-header" class="container-fluid p-0" [class.hide-on-mobile]="isMobile">
  <div class="row">
    <div class="col-md-4">
      <div class="d-flex align-items-center">
        <span class="logo-target">
          <img
            src="assets/img/target_logo.png"
            id="logo-target"
            height="40px"
            width="40px"
            alt="Target Sistemas"
            title="Target Sistemas"
          />
        </span>
        <img
          src="assets/img/rotaplan.ico"
          id="logo-rotaplan"
          alt="Logo"
          height="40px"
          width="40px"
        />

        <span id="header-title--media">
          <span id="header-title" class="ms-2">
            Target Rota Plan
          </span>

          <!-- Consumo maior que o liberado -->
          <div
            class="dropdown"
            *ngIf="qtdLiberada && qtdUsada > qtdLiberada"
            style="display: contents"
          >
            <button
              class="btn btn-outline-dark btn-sm sync-box me-2"
              type="button"
              data-bs-toggle="dropdown"
              (click)="visualizouAlerta()"
              aria-haspopup="true"
              aria-expanded="false"
              title="Consumo RotaPlan"
            >
              <i
                class="fa fa-exclamation-triangle fa-2x"
                [ngClass]="{ animationAviso: avisoConsumo }"
              >
              </i>
            </button>
            <div
              class="dropdown-menu dropdown-menu-right card_consumo"
              aria-labelledby="header-config"
            >
              <p class="text-center mb-0 pb-2 informacao_app">
                Consumo de Roteirização está acima do contratado para o mês de
                {{ mesConsumo }}
              </p>

              <table
                class="table table-sm table-striped"
                style="margin-bottom: 0px"
              >
                <thead>
                  <tr class="text-center">
                    <th class="text-center">Quantidade Contratada</th>
                    <th class="text-center">Roteiros Liberados</th>
                    <th class="text-center">Total de simulações e edições</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="text-center">
                    <td class="text-center">{{ qtdLiberada }}</td>
                    <td class="text-center">{{ qtdUsada }}</td>
                    <td class="text-center">{{ qtdSimu }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </span>
      </div>
    </div>
    <div class="pilula" *ngIf="exibePilulaAvaliacao" (click)="exibeModalAvaliacao()">
      <div class="estrelas">
        <img  src="assets/img/gold-star-small.svg" alt="estrela">
        <img  src="assets/img/gold-star-small.svg" alt="estrela">
        <img src="assets/img/gold-star-small.svg" alt="estrela">
        <img  src="assets/img/gold-star-small.svg" alt="estrela">
        <img  src="assets/img/gold-star-small.svg" alt="estrela">
      </div>
      <span>Avaliar!</span>
      <img src="assets/img/close-verde.svg" (click)="showPilulaAvaliacao()"  alt="botao fechar">
    </div>
    <app-modal-avaliacao *ngIf="dashboardService.exibirModalAvaliacao" [momento]="'INICIAL'" (closeModal)="fecharModal()"></app-modal-avaliacao> 
    <div class="dashboard-header col-md-8">
      <!--FILTRO DE ROTEIROS POR FILIAL - COMBOBOX-->
      <div
      *ngIf="listaEmpresas.length > 1"
      class="dropdown me-3"
      id="filtraPorFilial"
    >
    <button
    class="btn filtro-filial align-items-center d-flex justify-content-between  dropdown-toggle"
    type="button"
    id="dropdownMenuButton"
    data-bs-toggle="dropdown"
    aria-haspopup="true"
    aria-expanded="false"
  >
    <span class="text-left" *ngIf="cdEmp == undefined">Filial</span>
    <span class="text-right truncar-texto">{{ cdEmp !== undefined ? razaoSocial : "" }}</span>
    </button>
    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
      <button
        class="dropdown-item"
        *ngFor="let empresa of listaEmpresas"
        (click)="getRoteirosPorEmpresa(empresa.cdEmp, empresa.nomeFantasia)"
        >{{ empresa.cdEmp }} - {{ empresa.nomeFantasia }}</button
      >
      <button
        class="dropdown-item text-danger"
        (click)="resetFiltroEmpresa()"
        >Resetar Filtro</button
      >
    </div>
     </div>
      <!--BUSCA DE ROTEIRO-->
      <div id="buscaRoteiro" class="form-inline ms-auto">
        <div class="form-group position-relative d-flex align-items-center">
          <!-- TESTE -->
          <span class="pe-2 font-busca">Busca por:</span>
          <div id="toggle-busca">
            <div class="btn-group btn-group-toggle d-flex align-items-center" data-bs-toggle="buttons">
             
              <label class="active pe-2 font-busca" (click)="tipoFiltro('roteiro')" >
                <img [src]="filtroParametro == 'roteiro'?  'assets/img/marcado.svg' : 'assets/img/desmarcado.svg'"   class="me-2" >
                <input 
                  style="display: none;"
                
                  type="radio"
                  name="options1"
                  id="option1"
                  autocomplete="off"
                  checked
                /> Roteiro
              </label>
              <label class="pe-2 font-busca " (click)="tipoFiltro('pedido')">
                <img [src]="filtroParametro == 'pedido'?  'assets/img/marcado.svg' : 'assets/img/desmarcado.svg'"   class="me-2" >
                <input
                  style="display: none;"
                 
                  type="radio"
                  name="options2"
                  id="option2"
                  autocomplete="off"
                />Pedido
              </label>
            </div>
          </div>
          <!-- FIM TESTE -->
            <div class="input-busca">
              <input
              type="number"
              class="form-control"
              [(ngModel)]="numeroRoteiroBusca"
              placeholder="{{ placeholderBusca }}"
            />
            </div>
            <div class="input-group-append"   (click)="buscarRoteiro()"
            id="abrirVisualizadorDeRoteiros">
              <span class="input-group-text custom-search-icon"><i class="fa fa-search"></i></span>
            </div>
          </div>  
  
      </div>
      <div id="header-icons" class="d-flex">
        <button
          type="button"
          class="btn btn-outline-dark btn-sm sync-box"
          (click)="refreshTela()"
          [disabled]="loading"
        >
          <img src="assets/img/refresh.svg" alt="Cards" class="me-1">
          {{ loading ? "atualizando" : (today | date : "dd/MM/yy | HH:mm") }}
        </button>
      </div>

      <!-- Roteiros com versão desatualizadas  -->

      <div class="dropdown" *ngIf="jasperService.waitJasper" [hidden]="roteirosVersaoDesatualizada.length == 0">
        <button
          class="btn btn-outline-dark btn-sm sync-box "
          type="button"
          data-bs-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          title="Versao Aplicativo do Motorista"
        >
        <img *ngIf="jasperService.waitJasper"  src="assets/img/celular.svg" alt="Celular">
            <span class="versaoAppDesatualizado">{{
              roteirosVersaoDesatualizada.length
            }}</span>
        
        </button>
        <div
          class="dropdown-menu dropdown-menu-right card_versao_app"
          aria-labelledby="header-config"
        >
          <p class="text-justify mb-0 pb-2 informacao_app">
            Temos uma nova versão do aplicativo do motorista
            <span class="font-weight-bold"> {{ versaoAtualApp }}</span
            ><br />
            Os seguintes roteiros foram iniciados com uma versão antiga, quando
            for possível avise o motorista para atualizar.
          </p>
          <div class="table-versao-app">
            <table class="table table-sm table-striped modal_versao_app ps-2">
              <thead >
                <tr>
                  <th >Roteiro</th>
                  <th >Versão APP</th>
                  <th >Motorista</th>
                </tr>
              </thead>
              <tbody >
                <tr *ngFor="let roteiro of roteirosVersaoDesatualizada">
                  <td >{{ roteiro.NumeroRoteiro }}</td>
                  <td >{{ roteiro.VersaoApp }}</td>
                  <td >{{ roteiro.NomeMotorista }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          
          <div class="d-flex justify-content-end me-2 mt-2 gap-2">
            <button
              type="button"
              class="btn btn-secondary"
              (click)="exibirQrCodeDownload()"
              id="btnQrCodeApp"
            >
              QR Code
            </button>
            <a
              type="button"
              class="btn btn-success"
              [href]="urlDownload"
              id="btnRotaApp"
            >
              Download
            </a>
          </div>
        </div>
      </div>
      
      <!-- Roteiros com versão desatualizadas aplicativo da transportadora  -->
      <div class="dropdown" *ngIf="jasperService.waitJasper" [hidden]="versaoTranspDesatualizada.length == 0">
        <button
          class="btn btn-outline-dark btn-sm sync-box "
          type="button"
          data-bs-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          title="Versão Aplicativo da Transportadora"
        >
        <img *ngIf="jasperService.waitJasper"  src="assets/img/celular.svg" alt="Celular">
            <span class="versaoAppDesatualizado">{{
              versaoTranspDesatualizada.length
            }}</span>
        
        </button>
        <div
          class="dropdown-menu dropdown-menu-right card_versao_app"
          aria-labelledby="header-config"
        >
          <p class="text-justify mb-0 pb-2 informacao_app">
            Temos uma nova versão do aplicativo da transportadora
            <span class="font-weight-bold"> {{ versaoAtualTransp }}</span
            ><br />
            Quando
            for possível avise o transportadora para atualizar.
          </p>

          <table class="table table-sm table-striped modal_versao_app ps-2">
            <thead >
              <tr>
             
                <th >Versão APP</th>
                <th >Transportadora</th>
              </tr>
            </thead>
            <tbody >
              <tr *ngFor="let roteiro of versaoTranspDesatualizada">
        
                <td >{{ roteiro.VersaoApp }}</td>
                <td >{{ roteiro.NomeMotorista }}</td>
              </tr>
            </tbody>
          </table>
          <div class="d-flex justify-content-end me-2 mt-2 gap-2">
            <button
              type="button"
              class="btn btn-secondary"
              (click)="exibirQrCodeDownloadTransp()"
              id="btnQrCodeAppTransp"
            >
              QR Code
            </button>
            <a
              type="button"
              class="btn btn-success"           
              (click)="downloadApptransp()"
            >
              Download
            </a>
          </div>
        </div>
      </div>      

      
      <button
      type="button"
      [disabled]="!jasperService.waitJasper"
      class="btn btn-outline-dark btn-sm sync-box"
      data-bs-toggle="modal"
      data-bs-target="#modal-relatorios"
      title="Relatórios"
    >
      <img *ngIf="jasperService.waitJasper"  src="assets/img/relatorio.svg" alt="Relatórios">
      
      <i
        *ngIf="!jasperService.waitJasper"
        class="fa fa-circle-o-notch fa-spin fa-3x loaderJasper me-1"
        aria-hidden="true"
      ></i>
      
    </button>

      <button
        type="button"
        hidden="true"
        data-bs-toggle="modal"
        id="btnAvisosNovidades"
        data-bs-target="#modal-avisos-novidades"
      >
        <i class="fa fa-file me-1"> </i>
      </button>

      <button [hidden]="true"
          class="btn btn-outline-dark btn-sm sync-box"
          type="button"
          data-bs-toggle="modal"
          (click)="hide($event, false)"
          data-bs-target="#modalCards"
          title="Cards"
        >
        <img src="assets/img/cards.svg" alt="Cards">
      </button>

      <button
      class="btn btn-outline-dark btn-sm sync-box"
      type="button"
      title="Tokens"
      data-bs-toggle="modal"
      (click)="hide($event, false)"
      data-bs-target="#modalTokens"
      *ngIf="mostrarRecursoToken"
    >
     <img src="assets/img/tokens.svg" alt="Tokens">
    </button>

    
    <button
      class="btn btn-outline-dark btn-sm sync-box"
      type="button"
      title="Configurações" 
      data-bs-toggle="modal"
      (click)="hide($event, true)"
      data-bs-target="#popUp-Config"  

    >
      <img src="assets/img/configuracoes.svg" alt="Configurações">
    </button>
        
   
    </div>
  </div>
</header>

<!-- Modal -->
<div
  class="modal fade"
  id="modalCards"
  tabindex="-1"
  role="dialog"
  aria-labelledby="TituloModalCentralizado"
  aria-hidden="true"
  data-backdrop="static"
  data-keyboard="false"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header justify-content-between">
        <h5 class="modal-title" id="TituloModalCentralizado">Configurações</h5>
        <img
          class="bt-fechar"
          src="assets/img/icon_bt-limpar_header.svg"
          data-bs-dismiss="modal"
        />
      </div>
      <div class="modal-body">
        <p>Selecione abaixo os Cards que você gostaria de ver no dashboard:</p>

        <div class="custom-control custom-checkbox">
          <input
            type="checkbox"
            class="custom-control-input"
            id="card_clientes"
            [checked]="cardClientes.mostrar"
            (click)="removeCardClientes()"
          />
          <label class="custom-control-label" for="card_clientes"
            >Card de Clientes</label
          >
        </div>

        <div class="custom-control custom-checkbox">
          <input
            type="checkbox"
            class="custom-control-input"
            id="card_roteiros"
            [checked]="cardRoteiros.mostrar"
            (click)="removeCardRoteiros()"
          />
          <label class="custom-control-label" for="card_roteiros"
            >Card de Ocorrências por Roteiros</label
          >
        </div>

        <div class="custom-control custom-checkbox">
          <input
            type="checkbox"
            class="custom-control-input"
            id="card_sem_comunicacao"
            [checked]="cardSemComunicacao.mostrar"
            (click)="removeCardSemComunicacao()"
          />
          <label class="custom-control-label" for="card_sem_comunicacao"
            >Card de Motoristas Sem Comunicação</label
          >
        </div>

        <div class="custom-control custom-checkbox">
          <input
            type="checkbox"
            class="custom-control-input"
            id="card_ultimas_entregas"
            [checked]="cardUltimasEntregas.mostrar"
            (click)="removeUltimasEntregas()"
          />
          <label class="custom-control-label" for="card_ultimas_entregas"
            >Card de últimas entregas</label
          >
        </div>

        <div class="custom-control custom-checkbox">
          <input
            type="checkbox"
            class="custom-control-input"
            id="card_relatorios"
            [checked]="cardRelatorios.mostrar"
            (click)="removeCardRelatorios()"
          />
          <label class="custom-control-label" for="card_relatorios"
            >Card de Relatórios</label
          >
        </div>

        <div class="custom-control custom-checkbox">
          <input
            type="checkbox"
            class="custom-control-input"
            id="card_visitas"
            [checked]="cardVisitas.mostrar"
            (click)="removeCardVisitas()"
          />
          <label class="custom-control-label" for="card_visitas"
            >Card de Visitas</label
          >
        </div>
      </div>
      <div class="modal-footer justify-content-between">
        <button type="button" class="btn btn-success" data-bs-dismiss="modal" (click)="resetarPosicoes()">
          Resetar Posições
        </button>
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
          Fechar
        </button>
      </div>
    </div>
  </div>
</div>

<!-- *********************************************************************** -->

<body>
  <app-dados-entregas
   [totalClientes]="totais.totalClientes"
   [totalClientesAtendidos]="totais.totalClientesAtendidos"
   [totalClientesNaoAtendidos]="totais.totalClientesNaoAtendidos"
   [totalClientesNaoVisitados]="totais.totalClientesNaoVisitados"
   [totalClientesAnalise]="totais.totalClientesAnalise"
   (filtroAlterado)="filtroAlterado()"
  >
  </app-dados-entregas>

  <div *ngIf="loaderFiltro" class="loader-filtro loader--style1" title="0">
    <svg
      version="1.1"
      id="loader-1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width="200px"
      height="200px"
      viewBox="0 0 40 40"
      enable-background="new 0 0 40 40"
      xml:space="preserve"
    >
      <path
        opacity="0.2"
        fill="#5cb85c"
        d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946
        s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634
        c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"
      />
      <path
        fill="#5cb85c"
        d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0
        C22.32,8.481,24.301,9.057,26.013,10.047z"
      >
        <animateTransform
          attributeType="xml"
          attributeName="transform"
          type="rotate"
          from="0 20 20"
          to="360 20 20"
          dur="1s"
          repeatCount="indefinite"
        />
      </path>
    </svg>
  </div>
   

  <div class="container-fluid p-0" [class.hide-on-mobile]="isMobile"></div>
  <div class="row gridster-row" [class.hide-on-mobile]="isMobile">
    <!-- Espaço para os cards -->
    <div class="col-12">
      <!-- Grid dos cards -->
      <gridster [options]="options">
        <!-- Card de Roteiros com mais Ocorrencias  -->
        <div [class.hidden]="!cardRoteiros.mostrar">
          <gridster-item [item]="cardRoteiros.posicao">
            <div class="card-header--dashboard">
              <div class="card-header--title">
                <span class="ms-1"> Ocorrências Relatadas </span>
              </div>

              <!-- Btns de Deletar  e mover -->
              <div>
                <button class="drag-handler">
                  <img src="assets/img/bt-card-mover.svg" />
                </button>
              </div>
            </div>
            <div class="gridster-item-content" *ngIf="carregando.ocorrencias">
              <roteiros-ocorrencias-dashboard-card
                [ocorrencias]="ocorrencias"
                [totaisOcorrencias]="totaisOcorrencias"
              >
              </roteiros-ocorrencias-dashboard-card>
            </div>
            <div
              class="loading"
              *ngIf="primeiraCarga"
              style="
                position: absolute;
                top: 0;
                left: 0;
                height: 100%;
                width: 100%;
              "
            >

              <!-- SVG TESTE -->
              <div class="loader loader--style1" title="0">
                <svg
                  version="1.1"
                  id="loader-1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  width="200px"
                  height="200px"
                  viewBox="0 0 40 40"
                  enable-background="new 0 0 40 40"
                  xml:space="preserve"
                >
                  <path
                    opacity="0.2"
                    fill="#5cb85c"
                    d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946
                    s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634
                    c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"
                  />
                  <path
                    fill="#5cb85c"
                    d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0
                    C22.32,8.481,24.301,9.057,26.013,10.047z"
                  >
                    <animateTransform
                      attributeType="xml"
                      attributeName="transform"
                      type="rotate"
                      from="0 20 20"
                      to="360 20 20"
                      dur="1s"
                      repeatCount="indefinite"
                    />
                  </path>
                </svg>
              </div>
              <!-- FIM SVG TESTE   -->
            </div>
          </gridster-item>
        </div>

        <!-- Card de clientes -->
        <div [class.hidden]="!cardClientes.mostrar">
          <gridster-item [item]="cardClientes.posicao">
            <div class="card-header--dashboard">
              <div class="card-header--title">
                <span class=""> Status das Entregas</span>
              </div>

              <!-- Btns de Deletar  e mover -->
              <div>
                <button class="drag-handler">
                  <img src="assets/img/bt-card-mover.svg" />
                </button>
              </div>
            </div>

            <div class="gridster-item-content">
              <div class="container-fluid">
                <div class="row justify-content-between">
                  <div class="col-sm-12 text-center">
                    <div class="chart" *ngIf="carregando.clientes">
                     <app-status-das-entregas class="statusDasEntregas" [dashboardResult]="dashboardResult" [totais]="totais"></app-status-das-entregas>
                    </div>
                  </div>
                  <div class="col-md-12 col-sm-12 dados-area"></div>
                </div>
              </div>
            </div>
            <div
              class="loading"
              *ngIf="primeiraCarga"
              style="
                position: absolute;
                top: 0;
                left: 0;
                height: 100%;
                width: 100%;
              "
            >
              <!-- SVG TESTE -->
              <div class="loader loader--style1" title="0">
                <svg
                  version="1.1"
                  id="loader-1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  width="200px"
                  height="200px"
                  viewBox="0 0 40 40"
                  enable-background="new 0 0 40 40"
                  xml:space="preserve"
                >
                  <path
                    opacity="0.2"
                    fill="#5cb85c"
                    d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946
                    s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634
                    c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"
                  />
                  <path
                    fill="#5cb85c"
                    d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0
                    C22.32,8.481,24.301,9.057,26.013,10.047z"
                  >
                    <animateTransform
                      attributeType="xml"
                      attributeName="transform"
                      type="rotate"
                      from="0 20 20"
                      to="360 20 20"
                      dur="1s"
                      repeatCount="indefinite"
                    />
                  </path>
                </svg>
              </div>
              <!-- FIM SVG TESTE   -->
            </div>
          </gridster-item>
        </div>

        <!-- Card Motorista Sem Comunicacao -->

        <div [class.hidden]="!cardSemComunicacao.mostrar">
          <gridster-item [item]="cardSemComunicacao.posicao">
            <div
              class="card-header--dashboard"
              style="justify-content: space-between"
            >
              <div class="card-header--title">
                <span style="margin-right: 16px;">Comunicação </span>
              </div>

              <!-- Btns de Deletar  e mover -->
              <div>
                <button class="drag-handler">
                  <img src="assets/img/bt-card-mover.svg" />
                </button>
              </div>
            </div>
            <div
              class="gridster-item-content pt-3"
              *ngIf="carregando.semComunicacao"
            >
              <card-sem-comunicacao-dashboard
                [roteiros]="roteirosSemComunicacao"
                (abrirModalMapa)="visualizadorDeRoteiros($event, false)"
              ></card-sem-comunicacao-dashboard>
            </div>
            <div
              class="loading"
              *ngIf="primeiraCarga"
              style="
                position: absolute;
                top: 0;
                left: 0;
                height: 100%;
                width: 100%;
              "
            >
              <!-- SVG TESTE -->
              <div class="loader loader--style1" title="0">
                <svg
                  version="1.1"
                  id="loader-1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  width="200px"
                  height="200px"
                  viewBox="0 0 40 40"
                  enable-background="new 0 0 40 40"
                  xml:space="preserve"
                >
                  <path
                    opacity="0.2"
                    fill="#5cb85c"
                    d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946
                    s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634
                    c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"
                  />
                  <path
                    fill="#5cb85c"
                    d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0
                    C22.32,8.481,24.301,9.057,26.013,10.047z"
                  >
                    <animateTransform
                      attributeType="xml"
                      attributeName="transform"
                      type="rotate"
                      from="0 20 20"
                      to="360 20 20"
                      dur="1s"
                      repeatCount="indefinite"
                    />
                  </path>
                </svg>
              </div>
              <!-- FIM SVG TESTE   -->
            </div>
          </gridster-item>
        </div>

        <!--CARD Relatórios-->
        <div [class.hidden]="!cardAjusteLayout.mostrar" style="visibility: hidden;">
          <gridster-item [item]="cardAjusteLayout.posicao">
          </gridster-item>
        </div>

        <div [class.hidden]="!cardRelatorios.mostrar">
          <gridster-item [item]="cardRelatorios.posicao">
            <div class="card-header--dashboard">
              <div class="card-header--title">
                <span class="ms-1"> Relatórios </span>
              </div>

              <!-- Btns de Deletar  e mover -->
              <div>
                <button class="drag-handler">
                  <img src="assets/img/bt-card-mover.svg" />
                </button>
              </div>
            </div>
            <div class="gridster-item-content">
              <div class="container-fluid">
                <div class="row justify-content-between">
                  <div class="col-sm-12 scroll-table">
                    <div class="chart">
                      <app-relatorios-dashboard-card
                        [card]="true"
                      ></app-relatorios-dashboard-card>
                    </div>
                  </div>
                  <div class="col-md-12 col-sm-12 dados-area"></div>
                </div>
              </div>
            </div>

            <!--Teste Conexão-->

            <div
              class="loading"
              *ngIf="primeiraCarga"
              style="
                position: absolute;
                top: 0;
                left: 0;
                height: 100%;
                width: 100%;
              "
            >

              <!-- SVG TESTE -->
              <div class="loader loader--style1" title="0">
                <svg
                  version="1.1"
                  id="loader-1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  width="200px"
                  height="200px"
                  viewBox="0 0 40 40"
                  enable-background="new 0 0 40 40"
                  xml:space="preserve"
                >
                  <path
                    opacity="0.2"
                    fill="#5cb85c"
                    d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946
                        s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634
                        c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"
                  />
                  <path
                    fill="#5cb85c"
                    d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0
                        C22.32,8.481,24.301,9.057,26.013,10.047z"
                  >
                    <animateTransform
                      attributeType="xml"
                      attributeName="transform"
                      type="rotate"
                      from="0 20 20"
                      to="360 20 20"
                      dur="1s"
                      repeatCount="indefinite"
                    />
                  </path>
                </svg>
              </div>
              <!-- FIM SVG TESTE   -->
            </div>
          </gridster-item>
        </div>

          <!-- Card Últimas entregas -->
          <div [class.hidden]="!cardUltimasEntregas.mostrar">
            <gridster-item [item]="cardUltimasEntregas.posicao">
              <div 
                class="card-header--dashboard"
                style="justify-content: space-between"
              >
              <div class="card-header--title">
                <span class="">Últimas entregas</span>
              </div>
  
                <!-- Btns de Deletar  e mover -->
                <div>
                  <button class="drag-handler">
                    <img src="assets/img/bt-card-mover.svg" />
                  </button>

                  <button class="drag-handler me-5"  data-bs-toggle="modal"  data-bs-target="#modalUltimasEntregas">
                    <img src="assets/img/lupa.svg" width=""/>
                  </button>
                </div>
              </div>
              <div 
                class="gridster-item-content pt-3"
                *ngIf="carregando.semComunicacao"
              >
                <card-ultimas-entregas 
                  [ultimasEntregas]="ultimasEntregas" 
                  (abrirModalMapa)="visualizadorDeRoteiros($event, false)"       
                ></card-ultimas-entregas>
              </div>
              <div
                class="loading"
                *ngIf="primeiraCarga"
                style="
                  position: absolute;
                  top: 0;
                  left: 0;
                  height: 100%;
                  width: 100%;
                "
              >
                <!-- SVG TESTE -->
                <div class="loader loader--style1" title="0">
                  <svg
                    version="1.1"
                    id="loader-1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    width="200px"
                    height="200px"
                    viewBox="0 0 40 40"
                    enable-background="new 0 0 40 40"
                    xml:space="preserve"
                  >
                    <path
                      opacity="0.2"
                      fill="#5cb85c"
                      d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946
                      s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634
                      c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"
                    />
                    <path
                      fill="#5cb85c"
                      d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0
                      C22.32,8.481,24.301,9.057,26.013,10.047z"
                    >
                      <animateTransform
                        attributeType="xml"
                        attributeName="transform"
                        type="rotate"
                        from="0 20 20"
                        to="360 20 20"
                        dur="1s"
                        repeatCount="indefinite"
                      />
                    </path>
                  </svg>
                </div>
                <!-- FIM SVG TESTE   -->
              </div>
            </gridster-item>
          </div>


          <!-- Card Últimas entregas -->
          <div [class.hidden]="!cardVisitas.mostrar">
            <gridster-item [item]="cardVisitas.posicao">
              <div 
                class="card-header--dashboard"
                style="justify-content: space-between"
              >
              <div class="card-header--title d-flex justify-content-between w-100 " >
                <span class="">Visitas</span>
                <div class="me-5 titulo-filtro-visita d-flex align-items-center  no-drag">
                  <span class="me-2">Mostrar apenas roteiros:</span>

                <div class="select-visita-filter me-3 " tabindex="0" (click)="mostrarEsconderFiltroVisita()" >
                  <div class="select-box d-flex justify-content-between align-items-center">
                    <span>{{ textoFiltroBusca }}</span>
                  </div>
                  <div class="select-options" *ngIf="aberto" (click)="$event.stopPropagation()">
                    <label class="option" *ngFor="let item of filtroVisitaStatus">
                      <input
                        type="checkbox"
                        [(ngModel)]="item.check"
                        (change)="alteraFiltroVisita()"
                        (click)="$event.stopPropagation()">
                        <img [src]="'assets/img/input-check' + (item.check ? '-ok.svg' : '.svg')" class="me-2">  {{ item.titulo }}
                    </label>
                  </div>
                  </div>
                    <span class="me-2">Ordenar por:</span>
                     <div class="">
                        <select class="select-box" [(ngModel)]="ordenarSelecionado" (ngModelChange)="onOrdenar($event)">
                            <option value="roteiro">Número do Roteiro</option>
                            <option value="situacao">Situação</option>
                            <option value="entregas">Quantidade de Entregas</option>
                        </select>
                     </div>
                    <!-- Btns de Deletar  e mover -->
                  <button class="drag-handler mt-1 ">
                    <img src="assets/img/bt-card-mover.svg" />
                  </button>
                  </div>
                </div>
              </div>
              <div 
                class="gridster-item-content pt-3 scroll-table-visitas"
                *ngIf="carregando.semComunicacao"
              >
               <app-visitas 
                [dashboardResult]="dashboardResult"
                [filtroVisitaAtivoIDs]="filtroVisitaAtivoIDs"
                (abrirModalMapa)="visualizadorDeRoteiros($event, false)"   
                ></app-visitas>
              </div>
              <div
                class="loading"
                *ngIf="primeiraCarga"
                style="
                  position: absolute;
                  top: 0;
                  left: 0;
                  height: 100%;
                  width: 100%;
                "
              >
                <!-- SVG TESTE -->
                <div class="loader loader--style1" title="0">
                  <svg
                    version="1.1"
                    id="loader-1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    width="200px"
                    height="200px"
                    viewBox="0 0 40 40"
                    enable-background="new 0 0 40 40"
                    xml:space="preserve"
                  >
                    <path
                      opacity="0.2"
                      fill="#5cb85c"
                      d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946
                      s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634
                      c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"
                    />
                    <path
                      fill="#5cb85c"
                      d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0
                      C22.32,8.481,24.301,9.057,26.013,10.047z"
                    >
                      <animateTransform
                        attributeType="xml"
                        attributeName="transform"
                        type="rotate"
                        from="0 20 20"
                        to="360 20 20"
                        dur="1s"
                        repeatCount="indefinite"
                      />
                    </path>
                  </svg>
                </div>
                <!-- FIM SVG TESTE   -->
              </div>
            </gridster-item>
          </div>

          <div [class.hidden]="!cardAlertas.mostrar">
            <gridster-item [item]="cardAlertas.posicao">
              <div 
                class="card-header--dashboard"
                style="justify-content: space-between"
              >
              <div class="card-header--title">
                <span class="">Alertas</span>
              </div>
  
                <!-- Btns de Deletar  e mover -->
                <div>              
                  <button class="drag-handler">
                    <img src="assets/img/bt-card-mover.svg" />
                  </button>

                  <button class="drag-handler me-5"  data-bs-toggle="modal"  data-bs-target="#modalAlertas">
                    <img src="assets/img/lupa.svg" width=""/>
                  </button>
                </div>
              </div>
              <div 
                class="gridster-item-content pt-3"
                *ngIf="carregando.semComunicacao"
              >
                <app-alertas-card 
                  [isModal]="false"
                  [dashboardResult]="dashboardResult"       
                  (abrirModalMapa)="visualizadorDeRoteiros($event, false)"        
                ></app-alertas-card>
              </div>
              <div
                class="loading"
                *ngIf="primeiraCarga"
                style="
                  position: absolute;
                  top: 0;
                  left: 0;
                  height: 100%;
                  width: 100%;
                "
              >
                <!-- SVG TESTE -->
                <div class="loader loader--style1" title="0">
                  <svg
                    version="1.1"
                    id="loader-1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    width="200px"
                    height="200px"
                    viewBox="0 0 40 40"
                    enable-background="new 0 0 40 40"
                    xml:space="preserve"
                  >
                    <path
                      opacity="0.2"
                      fill="#5cb85c"
                      d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946
                      s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634
                      c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"
                    />
                    <path
                      fill="#5cb85c"
                      d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0
                      C22.32,8.481,24.301,9.057,26.013,10.047z"
                    >
                      <animateTransform
                        attributeType="xml"
                        attributeName="transform"
                        type="rotate"
                        from="0 20 20"
                        to="360 20 20"
                        dur="1s"
                        repeatCount="indefinite"
                      />
                    </path>
                  </svg>
                </div>
                <!-- FIM SVG TESTE   -->
              </div>
            </gridster-item>
          </div>         
          
          <div [class.hidden]="!cardCrossdocking.mostrar">
            <gridster-item [item]="cardCrossdocking.posicao">
              <div 
                class="card-header--dashboard"
                style="justify-content: space-between"
              >
              <div class="card-header--title">
                <span class="">Crossdocking</span>
              </div>
  
                <!-- Btns de Deletar  e mover -->
                <div class="no-drag d-flex align-items-center">   
                  <span class="titulo-filtro-visita mt-0 pe-1">Ponto apoio logístico:</span> 
                  <select class="select-box"   [ngModel]="pontoApoioSelecionado"  (ngModelChange)="filtroApoiologistico($event)" style="max-width: 200px;">
                    <option *ngFor="let pontoApoio of listaApoiologistico" [ngValue]="pontoApoio">
                       {{ pontoApoio }}
                    </option>
                  </select>         
                </div>
              </div>
              <div 
                class="gridster-item-content pt-3"
              >
              <app-card-crossdocking 
                [roteiros]="roteiros" 
                [pontoApoioSelecionado]="pontoApoioSelecionado"
                ></app-card-crossdocking>
              </div>
              <div
                class="loading"
                *ngIf="primeiraCarga"
                style="
                  position: absolute;
                  top: 0;
                  left: 0;
                  height: 100%;
                  width: 100%;
                "
              >
                <!-- SVG TESTE -->
                <div class="loader loader--style1" title="0">
                  <svg
                    version="1.1"
                    id="loader-1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    width="200px"
                    height="200px"
                    viewBox="0 0 40 40"
                    enable-background="new 0 0 40 40"
                    xml:space="preserve"
                  >
                    <path
                      opacity="0.2"
                      fill="#5cb85c"
                      d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946
                      s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634
                      c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"
                    />
                    <path
                      fill="#5cb85c"
                      d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0
                      C22.32,8.481,24.301,9.057,26.013,10.047z"
                    >
                      <animateTransform
                        attributeType="xml"
                        attributeName="transform"
                        type="rotate"
                        from="0 20 20"
                        to="360 20 20"
                        dur="1s"
                        repeatCount="indefinite"
                      />
                    </path>
                  </svg>
                </div>
                <!-- FIM SVG TESTE   -->
              </div>
            </gridster-item>
          </div>  


      </gridster>
    </div>
  </div>

  <section class="areaExpand" [class.open]="expand_class" [class.is-mobile]="isMobile">
    <div class="position-relative">
      <div id="botao-roteiros">
        <button   class="btn expand-btn d-flex align-items-center"
         >
        <span class="me-3" style="font-size: 16px;text-transform: none;" [class.hide-on-mobile]="isMobile">{{ roteiros?.length }} Roteiros </span>

          <div class="info-roteiros">   
            
            <div class="d-flex">

              <div class="d-flex" (click)="filtrarPorSituacao(1)" [ngClass]="{ 'filtro-ativo': filtroAtivo && idSituacaoFiltro === 1 }">       
                <img src="assets/img/icons/card_pendente_black.svg" class="ms-2 me-2" title="Roteiro em aberto" />
                <span class="font-totalizador border-right-custom">{{ totaisSituacoes.emAberto }}</span>     
              </div>   
              
              <div class="d-flex margin-situacao" (click)="filtrarPorSituacao(3)" [ngClass]="{ 'filtro-ativo': filtroAtivo && idSituacaoFiltro === 3 }">      
                <img src="assets/img/icons/card_pausa.svg" class="me-2 ms-3" title="Roteiro em pausa"/>
                <span class="font-totalizador border-right-custom">{{ totaisSituacoes.pausou }}</span>
              </div>
              
              <div class="d-flex margin-situacao" (click)="filtrarPorSituacao(2)" [ngClass]="{ 'filtro-ativo': filtroAtivo && idSituacaoFiltro === 2 }">      
                <img src="assets/img/icons/card_play.svg" class="me-2 ms-3" title="Roteiro inicializado" style="width: 8px;" />
                <span class="font-totalizador border-right-custom">{{ totaisSituacoes.iniciou }}</span>
              </div>
              
              <div class="d-flex margin-situacao" (click)="filtrarPorSituacao(5)" [ngClass]="{ 'filtro-ativo': filtroAtivo && idSituacaoFiltro === 5 }">      
                <img src="assets/img/icons/card_check_black.svg" class="me-2 ms-3" title="Roteiro finalizado"  />
                <span class="font-totalizador me-2">{{ totaisSituacoes.finalizou }}</span>
              </div>    
              
            </div>
        </div>
      </button>

        <div id="wrapper-search-roteiros">
          <input
            id="search-roteiros"
            type="search"
            placeholder="Buscar"
            [(ngModel)]="pesquisaAcoes"
          />
          <img *ngIf="!isMobile" class="chevron-card" src="assets/img/icons/chevron-icon-white.svg" [style.transform]="expand_class ? 'rotate(0deg)' : 'rotate(180deg)'" (click)="expandRoteiros()"  alt="">
          
          <button
            *ngIf="isMobile"
            class="btn btn-sm ms-2 btn-config-mobile"
            type="button"
            title="Configurações" 
            data-bs-toggle="modal"
            (click)="hide($event, true)"
            data-bs-target="#popUp-Config"
          >
            <img src="assets/img/configuracoes.svg" alt="Configurações">
          </button>
        </div>
      </div>

      <div
        class="roteiro_card"
        [class.open_roteiro_card]="expand_class"
        *ngIf="carregando.roteiros"
        (wheel)="onScroll($event)"
      >
        <roteiro-card
          *ngFor="
            let roteiro of roteiros
              | searchfilter
                : pesquisaAcoes
          "
          [dados]="roteiro"
          [totais]="dashboardResultTotal"
          data-bs-toggle="modal"
          data-bs-target="#modalPrincipal"
          style="cursor: pointer"
          (click)="visualizadorDeRoteiros(roteiro.roteiro, false)"
        ></roteiro-card>
      </div>
    </div>
  </section>

  <popup-config></popup-config>
  <popup-tokens></popup-tokens>
  <app-popup-temperatura-roteiro></app-popup-temperatura-roteiro>

  <!-- TESTE -->

  <!-- Modal -->


  <div
    class="modal fade"
    id="modalPrincipal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="TituloModalCentralizado"
    aria-hidden="true"
    data-backdrop="static"
    data-keyboard="false"
    style="padding-left: 0px !important;"
  >
    <div
      class="modal-dialog modal-dialog-centered"
      role="document"
      style="
        max-width: 98%;
        width: 100%;
        max-height: 90%;
        height: 100%;
        margin: 10px;
        padding: 0;
      "
    >
      <div
        class="modal-content"
        style="height: auto; min-height: 100%; border-radius: 10px"
      >
        <div class="modal-header justify-content-between">
          <img
            class="bt-fechar ms-auto"
            src="assets/img/icon_bt-limpar_header.svg"
            data-bs-dismiss="modal"
            id="voltaTelaInicial"
            (click)="voltarTelaInicial()"
          />
        </div>

        <div class="modal-body" style="display: flex">
          <rota-map></rota-map>
          <div class="header">
            <main-header-truck
              [roteiro]="roteiroModal"
              *ngIf="controlStatus.currentState == state.visualizadorDeRoteiros"
            ></main-header-truck>
          </div>

          <box-info-left
            [roteiro]="roteiroModal"
            *ngIf="controlStatus.currentState == state.visualizadorDeRoteiros"
          >
          </box-info-left>


        </div>
      </div>
    </div>
  </div>

  <popup-dist-percorrida></popup-dist-percorrida>
  <popup-relatorios></popup-relatorios>
  <popup-jasper></popup-jasper>
  <app-modal-formuilario-relatorios></app-modal-formuilario-relatorios>
  <app-popup-avisos-novidades></app-popup-avisos-novidades>
  <popup-ocorrencia-pedagio></popup-ocorrencia-pedagio>
  <app-popup-precos-praca-pedagio></app-popup-precos-praca-pedagio>
  <app-popup-dados-recebedor></app-popup-dados-recebedor>

  <button id="btnMostraAlertaNotic" (click)="mostraAlertaNotic()" [hidden]="true"></button>

  <app-alerta-notificacao *ngIf="mostraNotAlerta && !isMobile"
  [dashboardResult]="dashboardResult"     
  (abrirModalMapa)="visualizadorDeRoteiros($event, false)" 
  ></app-alerta-notificacao>
  
  <!-- fim teste -->

  <div
    id="loading-relatorios"
    class="open"
    [hidden]="!controlStatus.carregandoRelatorios"
  >
    <img
      class="img-loading"
      *ngIf="!this.controlStatus.erroRelatorio"
      src="assets/img/loading-preto.gif"
    />
    <span> {{ this.controlStatus.avisoRelatorio }} </span>
    <button
      class="bt-fechar"
      *ngIf="this.controlStatus.erroRelatorio"
      (click)="fecharLoading()"
    >
      <img class="ms-1" src="assets/img/bt_fechar_streetView.png" alt="" />
      Fechar
    </button>
  </div>

  <button [hidden]="true" (click)="resetarPosicoes()" id="btnResetarPosicoes">
    
  </button>



  <!-- Modal Local de entrega -->
  <div class="modal fade" id="modalLocalEntrega" tabindex="-8" role="dialog"  aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header justify-content-between">
          <p  class="mb-0 ms-1 modal-titulo" >Check-in via imagem</p>
          <img class="bt-fechar" data-bs-dismiss="modal" src="assets/img/icon_bt-limpar_header.svg" style="cursor: pointer;">
        </div>
        <div class="modal-body" >

          <div *ngIf="boxInfoRouterService.loadingLocalEntrega">
            <img src="/assets/img/loading.gif" alt="gif loading" class="me-3" width="20"> <span>Carregando
              informações</span>
          </div>

          
          <div class="" *ngIf="!boxInfoRouterService.loadingLocalEntrega;">
            <div class="d-flex flex-row mb-0">
              <h5 class="me-1 mb-0 text-black">{{ boxInfoRouterService.clienteLocalEntrega?.RazaoSocial }}</h5>
              <p class="font-size-14 mb-0 text-grey">({{ boxInfoRouterService.clienteLocalEntrega?.CodigoCliente }})</p>
            </div>
            
            <div>
              <p class="mb-0 text-grey">{{ boxInfoRouterService.clienteLocalEntrega?.RazaoSocial }}</p>
              <p class="text-grey">CNPJ: {{ boxInfoRouterService.clienteLocalEntrega?.CnpjCpf }}</p>
              <p class="mb-0 text-black">{{ boxInfoRouterService.clienteLocalEntrega?.Endereco }}, {{ boxInfoRouterService.clienteLocalEntrega?.Numero }}</p>
              <p class="mb-0 text-black">{{ boxInfoRouterService.clienteLocalEntrega?.Bairro }} - {{ boxInfoRouterService.clienteLocalEntrega?.Cidade }}</p>
              <p class="mb-0 text-black">CEP: {{ boxInfoRouterService.clienteLocalEntrega?.Cep }}</p>
              <div class="pb-1 border-bottom mb-3 mt-1"></div>
              <div class=" d-flex justify-content-center" *ngIf="boxInfoRouterService.clienteLocalEntrega?.arquivo != null">
                <img class="mt-1" width="445px" src="data:image/jpeg;base64,{{ boxInfoRouterService.clienteLocalEntrega?.arquivo }}" alt="Local da entrega"> 
              </div>    
          </div>
          </div> 
        </div>
      </div>
    </div>
  </div>

  

<!-- Ultimas entregas -->
<div class="modal fade full" id='modalUltimasEntregas' tabindex="-10" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true"
  data-backdrop="static" data-keyboard="false">

  <div class="modal-dialog modal-lg">
    <div class="modal-content">

      <div class="modal-header justify-content-between">
        <h5 class="modal-title"> Últimas entregas </h5>
        <img data-bs-dismiss="modal" class='bt-fechar' src="assets/img/icon_bt-limpar_header.svg" id="btnCloseUltimaEnrtega">
      </div>

      <div class="modal-body">  
        <div class="d-flex mt-3 ">  
          <div class="custom-scroll shadow bg-white w-100" >
            <card-ultimas-entregas 
            isModal="true"
            [ultimasEntregas]="ultimasEntregas" 
            (abrirModalMapa)="visualizadorDeRoteiros($event, false)"       
          ></card-ultimas-entregas>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal Alertas -->
<div class="modal fade full" id='modalAlertas' tabindex="-10" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true"
  data-backdrop="static" data-keyboard="false">

  <div class="modal-dialog modal-lg">
    <div class="modal-content">

      <div class="modal-header justify-content-between">
        <h5 class="modal-title"> Alertas </h5>
        <img data-bs-dismiss="modal" class='bt-fechar' src="assets/img/icon_bt-limpar_header.svg" id="btnCloseAlerta">
      </div>

      <div class="modal-body">  
        <div class="d-flex mt-3 ">  
          <div class="modal-alerta custom-scroll shadow bg-white w-100" >
            <app-alertas-card 
            [isModal]="true"
            [dashboardResult]="dashboardResult"
            (abrirModalMapa)="visualizadorDeRoteiros($event, false)"           
          ></app-alertas-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


  


</body>


